// import * as React from 'react';
// import {UniqueId} from '@nu-art/ts-common';
// import {GraphvizPathwayViewer} from './GraphvizComponents/index.js';
// import {Renderer_SearchResult, SearchItemV3} from '@app/styles';
// import {DB_Pathway, DBProto_Pathway, ModuleFE_Pathway} from '../_entity.js';
// import {Page_PathwayEditor} from './Page_PathwayEditor/index.js';
// import {CollectionEntityMapper} from '@app/hcs-frontend';
//
// export const searchItemKey_Pathway = ModuleFE_Pathway.dbDef.dbName;
//
// export const SearchableItem_Pathway: SearchItemV3<DBProto_Pathway> = {
// 	module: ModuleFE_Pathway,
// 	type: searchItemKey_Pathway,
// 	route: Page_PathwayEditor.Route(),
// 	entityName: ModuleFE_Pathway.dbDef.entityName,
// 	entityLabel: 'Pathway',
// 	groupId: ['Advisor'],
// 	mapper: (item) => [item.label],
// 	tags: [],
// 	renderer: (item: DB_Pathway, selected?: boolean, onClickCallback?: () => void) => {
// 		return <Renderer_SearchResult
// 			itemId={item._id}
// 			itemKey={searchItemKey_Pathway}
// 			itemLabel={item.label}
// 			entityLabel={'Pathway'}
// 			hierarchy={'Pathways'}
// 			selected={selected}
// 			onClickCallback={onClickCallback}
// 		/>;
// 	},
// 	resultRenderer: (item: UniqueId) => {
// 		return <GraphvizPathwayViewer pathwayId={item}/>;
// 	}
// };
//
// export const SearchableItem_PathwayV2: SearchItemV3<DBProto_Pathway> = {
// 	...SearchableItem_Pathway,
// 	renderer: (item: DB_Pathway, selected?: boolean, onClickCallback?: () => void) => {
// 		const type = item.type === 'chief-complaint' ? 'Chief Complaint' : 'Differential Diagnosis';
// 		return <Renderer_SearchResult
// 			itemId={item._id}
// 			itemKey={searchItemKey_Pathway}
// 			itemLabel={item.label}
// 			hierarchy={type}
// 			selected={selected}
// 			onClickCallback={onClickCallback}
// 		/>;
// 	},
// };
//
import { CollectionEntityMapper } from '@app/hcs-frontend/entities/CollectionEntityMapper';
import { Page_PathwayEditor } from './Page_PathwayEditor/index.js';
CollectionEntityMapper.addEntities([
    Page_PathwayEditor.SearchableItem_Pathway,
]);
//# sourceMappingURL=search-items.js.map